import Vue from 'vue'
import Vuex from 'vuex'
import moment from 'moment'
import trans from './trans'
import utils from '@/utils';
import config from '@/config';
import notify from '@/notify';
import eventBus from '@/main';
import partnerFinder from './partnerFinder'
import cancelNotification from './cancelNotification'
import MobileDetect from 'mobile-detect';

const localVue = new Vue();

Vue.use(Vuex)

const state = {
  auth: {
    userID: null,
    token: null,
  },
  clients: [],
  globalSubjectTypes: [],
  currentGlobalSubjectTypeKey: null,
  user: null,
  balances: [],

  subjectTypes: [],
  currentSubjectTypeID: null,
  currentTableDate: moment().format('YYYY-MM-DD'),
  tables: [],
  currentClientDomain: null,
  currentPosition: null,
  isAccessCurrentPosition: true,
  userReservations: null,
  filteredFreeClients: false,
  isDetailedFilterOpen: false,
  isListView: false,
  isLoading: {
    tables: true,
  },
  isMounted: {
    filterForClients: false,
  },
  isOfflineError: false,
  DATE_PICKER_LANG: {
    days: ['Vas', 'Hét', 'Ked', 'Sze', 'Csü', 'Pén', 'Szo'],
    months: ['Jan', 'Feb', 'Már', 'Ápr', 'Máj', 'Jún', 'Júl', 'Aug', 'Sze', 'Okt', 'Nov', 'Dec'],
    pickers: ['következő 7 nap', 'következő 30 nap', 'előző 7 nap', 'előző 30 nap'],
    placeholder: {
      date: '',
      dateRange: 'Intervallum választás',
    },
  },
  isGlobalMode: false,
  ownerDomain: null,
  timetableExtraOptions: [],
  trans: trans,

  // ---------- remoteSettings --------
  signupDisabled: false,
  passDisabled: false,
  cssApplied: false,
  availableItems: [],
  userPasses: [],
}

const mutations = {
  SET_OFFLINE_ERROR (state, data) {
    state.isOfflineError = data
  },  
  SET_STARTUP (state, data) {
    console.log('->mut.SET_STARTUP')
    state.clients = data.clients
    state.globalSubjectTypes = data.globalSubjectTypes
    // noinspection JSUnresolvedVariable
    state.isGlobalMode = data?.isGlobalRequest
    state.ownerDomain = data.ownerDomain

    if (data.globalSubjectTypes.length > 0) {
      state.currentGlobalSubjectTypeKey = data.globalSubjectTypes[0].key
    }

    if (data?.timetableExtraOptions)
      state.timetableExtraOptions = data.timetableExtraOptions

    if (data?.availableItems)
      state.availableItems = data.availableItems

    if (data?.userPasses)
      state.userPasses = data.userPasses

    if (data.user) {
      state.user = data.user
      state.balances = data.balances
    } else {
      state.user = null;
      state.balances = [];
    }

    // ---------- remoteSettings --------
    state.signupDisabled = data?.remoteSettings?.signupDisabled || false;
    state.passDisabled = data?.remoteSettings?.passDisabled || false;

    let ct = data?.remoteSettings?.clientTrans;
    if (ct) {
      for (let key0 in ct) {
        if (ct.hasOwnProperty(key0) && this.state.trans.hasOwnProperty(key0)) {
          let ct1 = ct[key0];
          for (let key1 in ct1) {
            if (ct1.hasOwnProperty(key1) && this.state.trans[key0].hasOwnProperty(key1)) {
              this.state.trans[key0][key1] = ct1[key1];
            }
          }
        }
      }
    }

  },
  SET_PASSES (state, data) {
    state.userPasses = data.userPasses || [];
    console.log('passes:', data);
  },
  SET_CLIENT (state, data) {
    console.log('>>>>>>>>>>>>>>>> SET CURRENT DOMAIN >>>>>>>>>>>>>>>>>>>>>>>>', data.domain);
    state.currentClientDomain = data.domain
    state.subjectTypes = data.subjectTypes
    if (data.subjectTypes.length > 0) {
      state.currentSubjectTypeID = data.subjectTypes[0].ID
    }
  },
  SET_TABLE (state, data) {
    state.tables = data.tables;
    Vue.set(state.isLoading, 'tables', false)
  },
  SET_TABLE_DATE (state, data) {
    state.currentTableDate = data.currentTableDate
  },
  SET_TABLE_SUBJECT (state, data) {
    state.currentSubjectTypeID = data.currentSubjectTypeID
  },
  SET_CURRENT_POSITION (state, data) {
    state.currentPosition = data.currentPosition
  },
  SET_IS_ACCESS_CURRENT_POSITION (state, data) {
    state.isAccessCurrentPosition = data.isAccessCurrentPosition
  },
  SET_USER_RESERVATIONS (state, data) {
    state.userReservations = data
  },
  CHANGE_USER_FAVORITE (state, data) {
    // eslint-disable-next-line no-prototype-builtins
    if (state.user && state.user.hasOwnProperty('favoriteClient')) {
      Vue.set(state.user, 'favoriteClient', data)
    }
  },
  SET_FILTERED_FREE_CLIENTS (state, data) {
    state.filteredFreeClients = data
  },
  // eslint-disable-next-line no-unused-vars
  TOGGLE_DETAILED_FILTER_OPEN (state, data) {
    state.isDetailedFilterOpen = !state.isDetailedFilterOpen
  },
  UN_SELECT_CLIENT (state) {
    Vue.set(state, 'currentClientDomain', null)
    Vue.set(state, 'tables', []);
  },
  // eslint-disable-next-line no-unused-vars
  TOGGLE_CLIENT_VIEW (state, data) {
    state.isListView = !state.isListView
  },
  SET_LOADING_STATE (state, data) {
    Vue.set(state.isLoading, data.name, data.state)
  },
  SET_MOUNTED_SATE (state, data) {
    Vue.set(state.isMounted, data.name, data.state)
  },
  SET_USER_PHONE_NUMBER (state, data) {
    Vue.set(state.user, 'phone', data.newPhoneNumber)
  },
  SET_USER_ADDRESS (state, data) {
    Vue.set(state.user, 'countryCode', data.countryCode)
    Vue.set(state.user, 'zipCode', data.zipCode)
    Vue.set(state.user, 'city', data.city)
    Vue.set(state.user, 'address', data.address)
  },
  SET_CSS_APPLIED (state, data) {
    state.cssApplied = data;
  },
  SET_AUTH (state, data) {
    state.auth.userID = data.userID;
    state.auth.token = data.token;
  },
  SUBSCRIBE_SUCCESS (state, data) {
    const row = state.balances.find(b => b.client === data.client);
    row.unsubscribed_at = data.unsubscribed_at;
    state.balances = [...state.balances];
  }
}

// =============================================================== ACTIONS =================================================
const actions = {
  // --------------------------------------- FETCH STARTUP ----------------------------------
  fetchStartUp ({ commit, dispatch, state, getters }) {
    console.log('--- FETCH STARTUP ---');
    commit('SET_AUTH', { userID: utils.getCookie('userID'), token: utils.getCookie('token') });

    let params = getters.getAuthParams;
    params.clientVersion = config.CURRENT_VERSION;


    Vue.http({
      url: config.SERVER_DOMAIN + '/api/global/startup',
      method: 'GET',
      params: params,
    }).then(
      (response) => {
        let data = response.body;
        commit('SET_STARTUP', data);

        /*if (data.favoriteClient) {
          TODO!
          this.selectClient({ domain: response.body.favoriteClient });
        }*/

        dispatch('setStartUpRaw', data); // new one for modules (too)

        if (getters.isLoggedIn) {
          //TODO: this.getUserReservations();
          dispatch('fetchTable');
        }

        var css = data.remoteSettings?.externalEmbedCss;
        if (css && !state.cssApplied) {
          let file = document.createElement('link');
          file.rel = 'stylesheet';
          file.href = css;
          document.head.appendChild(file);
          commit('SET_CSS_APPLIED', css);
        }

        if (utils.getCookie('isDigital') === 'true' && !getters.isDigitalMode) window.location.reload()
      },
      (error) => {
        utils.httpError(error);
      },
    );
  },

  fetchPasses ( {commit, getters }) {
    let params = getters.getAuthParams;
    params.clientVersion = config.CURRENT_VERSION;
    Vue.http({
      url: config.SERVER_DOMAIN + '/api/global/mypasses',
      method: 'GET',
      params: params,
    }).then(
      (response) => {
        let data = response.body;
        commit('SET_PASSES', data);
      },
      (error) => {
        utils.httpError(error);
      },
    );
  },

  // --------------------------------------- SELECT CLIENT ----------------------------------
  selectClient ({ commit, dispatch }, clientDomain) {
    console.log('--- select client ---', clientDomain);
    Vue.http({
      url: config.SERVER_DOMAIN + '/api/global/subjecttypes',
      method: 'GET',
      params: { domain: clientDomain },
    }).then(
      (response) => {
        let subjectTypes = response.body.subjectTypes;
        commit('SET_CLIENT', { subjectTypes: subjectTypes, domain: clientDomain });
        dispatch('fetchTable');
        eventBus.$emit('AfterSelectClient');
      },
      (error) => {
        utils.httpError(error);
      },
    )//then
  },
  // --------------------------------------- FETCH TABLE ----------------------------------
  fetchTable ({ commit, dispatch, state, getters }) {
    console.log('--- fetch table ---');
    let currentTableDate = state.currentTableDate;
    let currentSubjectTypeID = state.currentSubjectTypeID;
    let domain = state.currentClientDomain;


    if (domain) {
      let params = {
        date: currentTableDate,
        subjectType: currentSubjectTypeID,
        domain: domain,
      };

      params = { ...params, ...getters.getAuthParams };
      if (getters.isLoggedIn) {

        params.email = state.user.email;
      }

      if (!moment(params.date).isValid()) {
        notify.warning('Hibás dátumot adott meg, próbálja meg ismét');
      } else if (!Number(params.subjectType)) {
        notify.warning(
          'Hibás adatot próbál lekérdezni, kérjük frissítse az böngésző ablakot',
        );
      } else if (!domain) {
        notify.warning(
          'Hibás adatot próbál lekérdezni, kérjük frissítse az böngésző ablakot.',
        );
      } else {
        commit('SET_LOADING_STATE', { name: 'tables', state: true });
        Vue.http({
          url: config.SERVER_DOMAIN + '/api/global/table',
          method: 'GET',
          params: params,
        }).then(
          (response) => {
            // this.tables = processTableStatus(this.user.ID, response.body.tables)
            let tables;
            if (getters.isLoggedIn) {
              tables = processTableStatus(state.user.email, state.user.userType, response.body.tables);
            } else {
              tables = processTableStatus(null, null, response.body.tables);
            }
            let data = { tables };
            commit('SET_TABLE', data);
            dispatch('afterFetchTable', response.body); // modules can subscribe to handle extra data from table fetch request
            dispatch('appendTableExtras'); // modules can subscribe to append extra data to state.tables
            console.log('--- fetchTable success ---');
          },
          (error) => {
            utils.httpError(error);
          },
        );
      }
    }
  },
  setCurrentTableDate ({ commit }, data) {
    commit('SET_TABLE_DATE', data)
  },
  setCurrentSubjectType ({ commit }, data) {
    commit('SET_TABLE_SUBJECT', data)
  },
  decreaseCurrentDay ({ commit }) {
    let currentTableDate = state.currentTableDate
    let newTableDate = moment(currentTableDate).subtract(1, 'day').format('YYYY-MM-DD')
    commit('SET_TABLE_DATE', { currentTableDate: newTableDate })
  },
  increaseCurrentDay ({ commit }) {
    let currentTableDate = state.currentTableDate
    let newTableDate = moment(currentTableDate).add(1, 'day').format('YYYY-MM-DD')
    commit('SET_TABLE_DATE', { currentTableDate: newTableDate })
  },
  setCurrentPosition ({ commit }, data) {
    commit('SET_CURRENT_POSITION', data)
  },
  isAccessCurrentPosition ({ commit }, data) {
    commit('SET_IS_ACCESS_CURRENT_POSITION', data)
  },
  setUserReservations ({ commit }, data) {
    commit('SET_USER_RESERVATIONS', data)
  },
  changeUserFavorite ({ commit }, data) {
    commit('CHANGE_USER_FAVORITE', data)
  },
  setFilteredFreeClients ({ commit }, data) {
    commit('SET_FILTERED_FREE_CLIENTS', data)
  },
  // eslint-disable-next-line no-unused-vars
  toggleDetailedFilterOpen ({ commit }, data) {
    commit('TOGGLE_DETAILED_FILTER_OPEN')
  },
  unSelectClient ({ commit }) {
    commit('UN_SELECT_CLIENT')
  },
  toggleClientView ({ commit }) {
    commit('TOGGLE_CLIENT_VIEW')
  },
  setMountedState ({ commit }, data) {
    commit('SET_MOUNTED_SATE', data)
  },
  setUserPhoneNumber ({ commit, state }, data) {
    if (state.user) {
      commit('SET_USER_PHONE_NUMBER', data)
    }
  },
  setUserAddress ({ commit, state }, data) {
    if (state.user && data?.countryCode && data?.zipCode && data?.city && data?.address) {
      commit('SET_USER_ADDRESS', data)
    }
  },
  appendTableExtras () {
    // use this as event if a table
  },
  startPOSPaymentWithReservationCode ({ getters }, reservationCode) {
    Vue.http({
      url: config.SERVER_DOMAIN + '/api/global/start-with-reservation-code-pos',
      method: 'POST',
      params: {
        ...getters.getAuthParams,
        reservationCode: reservationCode,
      },
    }).then(
      (resp) => {
        if (resp.data && resp.data.needPOSPayment) window.location.href = resp.data.needPOSPayment.Url
      },
      (error) => {
        utils.httpError(error)
      },
    );
  },
  startOtherItemsPOSPayment ({ getters }, payload) {
    Vue.http({
      url: config.SERVER_DOMAIN + '/api/global/buy-other-items-pos',
      method: 'POST',
      params: {
        ...getters.getAuthParams,
        boughtItems: payload.boughtItems,
        reservationCode: payload.reservationCode,
      },
    }).then(
      (resp) => {
        console.log('startOtherItemsPOSPayment', resp.data.needPOSPayment)
        if (resp.data && resp.data.needPOSPayment) window.location.href = resp.data.needPOSPayment.Url
      },
      (error) => {
        utils.httpError(error)
      },
    );

  },
  startPassBuyWithCard ({ getters }, payload) {
    Vue.http({
      url: config.SERVER_DOMAIN + '/api/global/buy-pass-with-online-card',
      method: 'POST',
      params: {
        ...getters.getAuthParams,
        boughtItems: payload.boughtItems,
        client: payload.client,
      },
    }).then(
      (resp) => {
        if (resp.data?.Method) {
          if (resp.data?.Method === 'SUMUP_CARD') {
            localVue.$modal.hide('pass-buy-modal')
            localVue.$modal.show('sum-up-payment-modal', {
              data: resp.data.Params,
            })
          } else {
            notify.error(`Ismeretlen fizetési mód: "${resp.data?.method}"`);
          }

        } else {
          notify.error(`Fizetési hiba`);
        }
      },
      (error) => {
        utils.httpError(error)
      },
    );

  },

  doNewsletterUnsubscribe ({ commit, getters }, { client, isSubscribe } ) {
    Vue.http({
      url: config.SERVER_DOMAIN + '/api/global/newsletter/unsubscribe',
      method: 'POST',
      params: {
        ...getters.getAuthParams,
      },
      body: {
        data : {
          subClient : client, isSubscribe
        }
      }
    }).then(
      (resp) => {
        if (resp.data && resp.data.ok) {
          commit('SUBSCRIBE_SUCCESS', { client, unsubscribed_at : !isSubscribe });
          notify.success(isSubscribe ? 'Sikeres feliratkozás' : 'Sikeres leiratkozás')
        } else 
          notify.erro('Hiba');
      },
      (error) => {
        utils.httpError(error);
      },
    );
  },  
}

// ====================================================== GETTERS =============================================
const getters = {
  getAuthParams: (state, getters) => {
    if (getters.isLoggedIn) {
      return {
        userID: state.auth.userID,
        token: state.auth.token,
        client: state.currentClientDomain,
      }
    } else {
      return {
        client: state.currentClientDomain,
      }
    }
  },
  getClientConfig: state => clientDomain => {
    const client = state.clients.find(client => client.domain === clientDomain)
    return client && client?.config ? client.config : false
  },
  getSelectedClientConfig: state => {
    const client = state.clients.find(client => client.domain === state.currentClientDomain)
    return client && client?.config ? client.config : false
  },
  getClientTimetableExtraOptionsBySubjectType: state => (clientDomain, subjectType) => {
    return state.timetableExtraOptions.filter(options => options.client === clientDomain && options.subjectType === subjectType)
  },
  getCurrentUserPaymentConfig: state => {
    const clients = state.clients
    const currentClientDomain = state.currentClientDomain
    for (let client of clients) {
      if (client?.domain === currentClientDomain || client?.domain === state.ownerDomain) {
        return client.config?.payment
      }
    }
    return false
  },
  getCurrentClientBalance: state => {
    const currentClientDomain = state.currentClientDomain
    const balances = state.balances
    for (let balance of balances) {
      if (balance.client === currentClientDomain || balance.client === state.ownerDomain) {
        return balance?.amount
      }
    }
    return false
  },
  isLoggedIn: (state) => {
    return !!(state.auth.userID && state.auth.token);
  },
  getOwnEmail: state => {
    return state.user?.email;
  },
  // eslint-disable-next-line
  getTableIterator: state => {
    let tables = JSON.parse(JSON.stringify(state.tables));
    return {
      tables,
      foreachTimeBlock: (cb) => {
        for (let table of tables || []) {
          for (let day of table.days || []) {
            for (let subject of day.subjects || []) {
              for (let tb of subject.fill || []) {
                cb(tb, { date: day.date, subject_type_id: subject.subject_type_id });
              } // for tb
            } // for subject
          } // for day
        } // for table
      },
    };
  },
  /*
  // eslint-disable-next-line
  getReservationsAt: (getters, state) => time => {
    // eslint-disable-next-line
    getters.getTableIterator.foreachTimeBlock(item => {

    });
  }*/
  isDigitalMode (/*state*/) {
    // return state.auth.userID && state.auth.token && state.user?.userType === 'digital'
    return utils.getCookie('isDigital') === 'true'
    // return Number(state.auth.userID) === 62795
  },
  isMobileDevice () {
    let md = new MobileDetect(window.navigator.userAgent);
    return !!(md.mobile() || md.phone() || window.innerWidth < 640);
  },
} // getters

export default new Vuex.Store({
  state,
  getters,
  actions,
  mutations,
  modules: {
    partnerFinder,
    cancelNotification,
  },
});


export function processTableStatus (currentUserEmail, currentUserType, tables) {
  console.log('-------- processtable --------');
  // currentUserID = Number(currentUserID)
  let tableIndex = 0;
  for (let table of tables) {
    table.tableIndex = tableIndex;
    if (table.hasOwnProperty('days')) {
      for (let day of table.days) {
        if (day.hasOwnProperty('subjects')) {
          for (let subject of day.subjects) {
            if (subject.hasOwnProperty('fill')) {
              for (let timeBlock of subject.fill) {
                if (!timeBlock.hasOwnProperty('startTime')) {
                  console.error('fill without \'startTime\'!!! status:' + timeBlock?.status);
                }
                if (
                  timeBlock.hasOwnProperty('status') &&
                  timeBlock.hasOwnProperty('ownerEmail')
                ) {
                  let isClub = Number(timeBlock.isClub);
                  if (isClub) {
                    // club reservation
                    timeBlock.status = 'club';
                  } else {
                    // normal reservation
                    if (timeBlock.status === 'reserved') {
                      if (timeBlock.ownerEmail === currentUserEmail) {
                        if (currentUserType) {
                          if (currentUserType === 'trainer') {
                            timeBlock.status = 'own-trainer';
                          } else {
                            timeBlock.status = 'own';
                          }
                        } else {
                          timeBlock.status = 'own';
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    tableIndex++;
  } // for table
  return tables;
}
